/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Term_L6Inputs */

const en_mk_term_l6 = /** @type {(inputs: Mk_Term_L6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`  … agent fixes the +62 validation …`)
};

const id_mk_term_l6 = /** @type {(inputs: Mk_Term_L6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`  … agent memperbaiki validasi +62 …`)
};

/**
* | output |
* | --- |
* | "… agent fixes the +62 validation …" |
*
* @param {Mk_Term_L6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_term_l6 = /** @type {((inputs?: Mk_Term_L6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Term_L6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_term_l6(inputs)
	return en_mk_term_l6(inputs)
});